import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";
import config from "./config.json";

export const startNewRelic = (surface) => {
  const licenseKey = String(config.NEW_RELIC_LICENSE_KEY || "").trim();
  const applicationID = String(config.NEW_RELIC_APPLICATION_ID || "").trim();
  const accountID = String(config.NEW_RELIC_ACCOUNT_ID || "").trim();
  const trustKey = String(config.NEW_RELIC_TRUST_KEY || accountID).trim();
  const agentID = String(config.NEW_RELIC_AGENT_ID || applicationID).trim();
  if (config.NEW_RELIC_ENABLED === false || !licenseKey || !applicationID) return null;

  return new BrowserAgent({
    init: {
      browser_consent_mode: { enabled: false },
      privacy: { cookies_enabled: true },
      distributed_tracing: { enabled: true },
      performance: { capture_measures: true },
      ajax: { deny_list: ["bam.nr-data.net"], capture_payloads: "none" },
    },
    info: {
      beacon: "bam.nr-data.net",
      errorBeacon: "bam.nr-data.net",
      licenseKey,
      applicationID,
      sa: 1,
      jsAttributes: { appSurface: surface },
    },
    loader_config: {
      accountID,
      trustKey,
      agentID,
      licenseKey,
      applicationID,
    },
  });
};
